// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Check, X, ChevronsUpDown, ArrowRight, SkipForward, RotateCcw, Filter, ArrowDown } from 'lucide-react';

// // --- HELPER FUNCTIONS & UTILS ---
// const shuffleArray = (array) => {
//     return [...array].sort(() => Math.random() - 0.5);
// };

// // --- SUB-COMPONENTS ---

// // 1. Single Choice Question Component
// const SingleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => {
//     return (
//         <div>
//             <p className="text-lg font-semibold text-gray-800 mb-4">{question}</p>
//             <div className="space-y-3">
//                 {options.map((option, index) => (
//                     <label key={index} className={`flex items-center p-3 rounded-lg border transition-all duration-200 ${
//                         userAnswer === option 
//                             ? 'bg-blue-100 border-blue-400 ring-2 ring-blue-300' 
//                             : 'bg-white border-gray-300 hover:bg-gray-50'
//                     } ${submitted ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
//                         <input
//                             type="radio"
//                             name="single-choice"
//                             value={option}
//                             checked={userAnswer === option}
//                             onChange={(e) => onAnswer(e.target.value)}
//                             disabled={submitted}
//                             className="mr-3 h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300"
//                         />
//                         <span className="text-gray-700">{option}</span>
//                     </label>
//                 ))}
//             </div>
//         </div>
//     );
// };

// // 2. Multiple Choice Question Component
// const MultipleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => {
//     const handleCheckboxChange = (option) => {
//         const newAnswer = userAnswer.includes(option)
//             ? userAnswer.filter(item => item !== option)
//             : [...userAnswer, option];
//         onAnswer(newAnswer);
//     };

//     return (
//         <div>
//             <p className="text-lg font-semibold text-gray-800 mb-4">{question}</p>
//             <div className="space-y-3">
//                 {options.map((option, index) => (
//                     <label key={index} className={`flex items-center p-3 rounded-lg border transition-all duration-200 ${
//                         userAnswer.includes(option)
//                             ? 'bg-blue-100 border-blue-400 ring-2 ring-blue-300'
//                             : 'bg-white border-gray-300 hover:bg-gray-50'
//                     } ${submitted ? 'cursor-not-allowed' : 'cursor-pointer'}`}>
//                         <input
//                             type="checkbox"
//                             checked={userAnswer.includes(option)}
//                             onChange={() => handleCheckboxChange(option)}
//                             disabled={submitted}
//                             className="mr-3 h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
//                         />
//                         <span className="text-gray-700">{option}</span>
//                     </label>
//                 ))}
//             </div>
//         </div>
//     );
// };

// // 3. Match The Following Question Component
// const MatchTheFollowingQuestion = ({ question, left, right, userAnswer, onAnswer, submitted }) => {
//     const [rightItems, setRightItems] = useState(userAnswer);

//     useEffect(() => {
//         setRightItems(userAnswer);
//     }, [userAnswer]);
    
//     const handleDragStart = (e, index) => {
//         if (submitted) return;
//         e.dataTransfer.setData('draggedIndex', index);
//     };

//     const handleDragOver = (e) => {
//         if (submitted) return;
//         e.preventDefault();
//     };
    
//     const handleDrop = (e, dropIndex) => {
//         if (submitted) return;
//         const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
//         const newRightItems = [...rightItems];
//         const [draggedItem] = newRightItems.splice(draggedIndex, 1);
//         newRightItems.splice(dropIndex, 0, draggedItem);
//         setRightItems(newRightItems);
//         onAnswer(newRightItems);
//     };

//     return (
//         <div>
//             <p className="text-lg font-semibold text-gray-800 mb-4">{question}</p>
//             <div className="flex justify-between max-w-2xl mx-auto">
//                 {/* Left Column */}
//                 <div className="w-5/12 space-y-3">
//                     {left.map((item, index) => (
//                         <div key={index} className="p-3 bg-gray-100 border border-gray-300 rounded-lg text-gray-800 h-16 flex items-center justify-center text-center">
//                             {item}
//                         </div>
//                     ))}
//                 </div>
//                 {/* Right Column (Draggable) */}
//                 <div className="w-5/12 space-y-3">
//                     {rightItems.map((item, index) => (
//                         <div
//                             key={index}
//                             draggable={!submitted}
//                             onDragStart={(e) => handleDragStart(e, index)}
//                             onDragOver={handleDragOver}
//                             onDrop={(e) => handleDrop(e, index)}
//                             className={`p-3 bg-white border-2 border-dashed border-gray-400 rounded-lg h-16 flex items-center justify-between text-center text-gray-700 ${!submitted ? 'cursor-grab active:cursor-grabbing' : 'cursor-not-allowed bg-gray-50'}`}
//                         >
//                             <span>{item}</span>
//                             {!submitted && <ChevronsUpDown className="h-5 w-5 text-gray-400" />}
//                         </div>
//                     ))}
//                 </div>
//             </div>
//         </div>
//     );
// };

// // 4. Reorder Question Component
// const ReorderQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => {
//      const [items, setItems] = useState(userAnswer);

//     useEffect(() => {
//         setItems(userAnswer);
//     }, [userAnswer]);

//     const handleDragStart = (e, index) => {
//         if (submitted) return;
//         e.dataTransfer.setData('draggedIndex', index);
//     };

//     const handleDragOver = (e) => {
//         if (submitted) return;
//         e.preventDefault();
//     };
    
//     const handleDrop = (e, dropIndex) => {
//         if (submitted) return;
//         const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
//         const newItems = [...items];
//         const [draggedItem] = newItems.splice(draggedIndex, 1);
//         newItems.splice(dropIndex, 0, draggedItem);
//         setItems(newItems);
//         onAnswer(newItems);
//     };

//     return (
//         <div>
//             <p className="text-lg font-semibold text-gray-800 mb-4">{question}</p>
//             <div className="space-y-3 max-w-md mx-auto">
//                    {items.map((item, index) => (
//                     <div
//                         key={index}
//                         draggable={!submitted}
//                         onDragStart={(e) => handleDragStart(e, index)}
//                         onDragOver={handleDragOver}
//                         onDrop={(e) => handleDrop(e, index)}
//                         className={`p-3 bg-white border-2 border-dashed border-gray-400 rounded-lg flex items-center justify-between text-gray-700 ${!submitted ? 'cursor-grab active:cursor-grabbing' : 'cursor-not-allowed bg-gray-50'}`}
//                     >
//                         <span>{index + 1}. {item}</span>
//                         {!submitted && <ChevronsUpDown className="h-5 w-5 text-gray-400" />}
//                     </div>
//                    ))}
//             </div>
//         </div>
//     );
// };

// // 5. Results Component
// const Results = ({ questions, userAnswers, onRestart }) => {
//     const [filter, setFilter] = useState('all');

//     const score = useMemo(() => {
//         return userAnswers.filter(ans => ans.isCorrect).length;
//     }, [userAnswers]);

//     const filteredQuestions = useMemo(() => {
//         if (filter === 'all') return questions;
//         if (filter === 'correct') {
//             return questions.filter(q => userAnswers.find(a => a.questionId === q.id)?.isCorrect);
//         }
//         if (filter === 'incorrect') {
//             return questions.filter(q => {
//                 const answer = userAnswers.find(a => a.questionId === q.id);
//                 return answer && answer.status === 'answered' && !answer.isCorrect;
//             });
//         }
//         if (filter === 'unanswered') {
//             return questions.filter(q => userAnswers.find(a => a.questionId === q.id)?.status !== 'answered');
//         }
//         return questions;
//     }, [filter, questions, userAnswers]);

//     const ReorderVisualizer = ({ items, className, title }) => (
//         <div>
//             <h4 className="font-medium text-gray-600 mb-2">{title}</h4>
//             <div className="flex flex-col items-center space-y-1">
//                 {items.map((item, index) => (
//                     <React.Fragment key={index}>
//                         <div className={`p-2 rounded-lg w-full text-center ${className}`}>
//                            {index + 1}. {item}
//                         </div>
//                         {index < items.length - 1 && (
//                             <ArrowDown className={`h-5 w-5 text-gray-400`} />
//                         )}
//                     </React.Fragment>
//                 ))}
//             </div>
//         </div>
//     );

//     const MatchVisualizer = ({ left, right, className, title }) => (
//         <div>
//             <h4 className="font-medium text-gray-600 mb-2">{title}</h4>
//             <div className="grid grid-cols-[1fr,auto,1fr] gap-2 items-center">
//                 {left.map((leftItem, index) => (
//                     <React.Fragment key={index}>
//                         <div className={`p-2 bg-gray-100 rounded text-gray-500 text-right`}>{leftItem}</div>
//                         <ArrowRight className="h-4 w-4 text-gray-400" />
//                         <div className={`p-2 rounded ${className}`}>{right[index]}</div>
//                     </React.Fragment>
//                 ))}
//             </div>
//         </div>
//     );


//     return (
//         <div className="max-w-4xl mx-auto">
//             <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">Quiz Results</h2>
//             <div className="bg-white p-6 rounded-xl shadow-lg mb-6 text-center">
//                 <p className="text-xl text-gray-700">Your Score:</p>
//                 <p className="text-5xl font-bold text-blue-600 my-2">{score} / {questions.length}</p>
//                 <p className="text-lg text-gray-600">{questions.length > 0 ? Math.round((score / questions.length) * 100) : 0}%</p>
//                 <button 
//                     onClick={onRestart}
//                     className="mt-6 inline-flex items-center px-6 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
//                 >
//                     <RotateCcw className="h-5 w-5 mr-2" />
//                     Retake Quiz
//                 </button>
//             </div>
            
//             <div className="flex items-center justify-between mb-4">
//                 <h3 className="text-xl font-bold text-gray-800">Review Answers</h3>
//                 <div className="flex items-center space-x-2 bg-gray-100 p-1 rounded-lg">
//                     <Filter className="h-5 w-5 text-gray-500 ml-2" />
//                     {['all', 'correct', 'incorrect', 'unanswered'].map(f => (
//                         <button
//                             key={f}
//                             onClick={() => setFilter(f)}
//                             className={`px-3 py-1 text-sm font-medium rounded-md capitalize transition-colors ${filter === f ? 'bg-white text-blue-600 shadow' : 'text-gray-600 hover:bg-gray-200'}`}
//                         >
//                             {f}
//                         </button>
//                     ))}
//                 </div>
//             </div>

//             <div className="space-y-4">
//                 {filteredQuestions.map((q, qIndex) => {
//                     const answer = userAnswers.find(a => a.questionId === q.id);
//                     const isAnswered = answer?.status === 'answered';
//                     const isCorrect = answer?.isCorrect || false;

//                     return (
//                         <div key={q.id} className={`bg-white p-4 rounded-lg shadow-md border-l-4
//                             ${!isAnswered ? 'border-gray-400' : isCorrect ? 'border-green-500' : 'border-red-500'}`}>
//                             <div className="flex justify-between items-center">
//                                 <p className="font-semibold text-gray-800 pr-4">{qIndex + 1}. {q.question}</p>
//                                 <div>
//                                     {!isAnswered && <span className="text-xs font-semibold px-2.5 py-1 bg-gray-200 text-gray-700 rounded-full">Unanswered</span>}
//                                     {isAnswered && isCorrect && <span className="text-xs font-semibold px-2.5 py-1 bg-green-100 text-green-800 rounded-full">Correct</span>}
//                                     {isAnswered && !isCorrect && <span className="text-xs font-semibold px-2.5 py-1 bg-red-100 text-red-800 rounded-full">Incorrect</span>}
//                                 </div>
//                             </div>
                            
//                             <div className="mt-3 text-sm space-y-4">
//                                 { !isAnswered && <p className="text-gray-500 italic">Not Answered</p>}

//                                 { q.type === 'reorder' && isAnswered && (
//                                     <div className="grid md:grid-cols-2 gap-4">
//                                         <ReorderVisualizer items={answer.answer} title="Your Order" className="bg-blue-100 border border-blue-200 text-blue-900" />
//                                         {!isCorrect && <ReorderVisualizer items={q.answer} title="Correct Order" className="bg-green-100 border border-green-200 text-green-900" />}
//                                     </div>
//                                 )}

//                                 { q.type === 'match-the-following' && isAnswered && (
//                                     <div className="grid md:grid-cols-2 gap-6">
//                                         <MatchVisualizer left={q.left} right={answer.answer} title="Your Matches" className="bg-blue-100 text-blue-900" />
//                                         {!isCorrect && <MatchVisualizer left={q.answer.map(p => p.left)} right={q.answer.map(p => p.right)} title="Correct Matches" className="bg-green-100 text-green-900" />}
//                                     </div>
//                                 )}

//                                 { q.type !== 'reorder' && q.type !== 'match-the-following' && isAnswered && (
//                                     <div className="text-gray-900">
//                                         <p><strong className="font-medium text-gray-600">Your Answer:</strong> {Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer}</p>
//                                         {!isCorrect && (
//                                             <p className="mt-1"><strong className="font-medium text-gray-600">Correct Answer:</strong> {Array.isArray(q.answer) ? q.answer.join(', ') : q.answer}</p>
//                                         )}
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     );
//                 })}
//             </div>
//         </div>
//     );
// };


// // --- MAIN QUIZ COMPONENT ---
// export default function QuizPlayer({ quizData, onComplete, onRestartQuiz }) {
//     useEffect(() => {
//         const scriptId = 'tailwind-cdn-script';
//         if (document.getElementById(scriptId)) return;
//         const script = document.createElement('script');
//         script.id = scriptId;
//         script.src = 'https://cdn.tailwindcss.com?plugins=forms';
//         document.head.appendChild(script);
//     }, []);

//     const [questions, setQuestions] = useState([]);
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//     const [userAnswers, setUserAnswers] = useState([]);
//     const [currentAnswer, setCurrentAnswer] = useState(null);
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [skippedIndexes, setSkippedIndexes] = useState([]);
//     const [quizState, setQuizState] = useState('in-progress'); // 'in-progress', 'review-skipped', 'completed'
    
//     // Initialize quiz
//     useEffect(() => {
//         if (!quizData || quizData.length === 0) return;

//         const preparedQuestions = quizData.map(q => {
//             if (q.type === 'match-the-following') {
//                 return { ...q, right: shuffleArray(q.right) };
//             }
//             if (q.type === 'reorder') {
//                 return { ...q, options: shuffleArray(q.options) };
//             }
//             return q;
//         });
//         setQuestions(preparedQuestions);
//         resetCurrentAnswer(preparedQuestions[0]);
//     }, [quizData]);

//     const resetCurrentAnswer = (question) => {
//         if (!question) return;
//         switch (question.type) {
//             case 'single-choice':
//                 setCurrentAnswer('');
//                 break;
//             case 'multiple-choice':
//                 setCurrentAnswer([]);
//                 break;
//             case 'match-the-following':
//                 setCurrentAnswer(question.right);
//                 break;
//             case 'reorder':
//                 setCurrentAnswer(question.options);
//                 break;
//             default:
//                 setCurrentAnswer(null);
//         }
//     };
    
//     const currentQuestion = questions[currentQuestionIndex];
//     const isLastQuestion = currentQuestionIndex === questions.length - 1;
//     const isLastSkippedQuestion = quizState === 'review-skipped' && skippedIndexes.length === 1;

//     const checkAnswer = useCallback(() => {
//         const question = currentQuestion;
//         let isCorrect = false;
//         switch (question.type) {
//             case 'single-choice':
//                 isCorrect = currentAnswer === question.answer;
//                 break;
//             case 'multiple-choice':
//                  isCorrect = currentAnswer.length === question.answer.length &&
//                     currentAnswer.sort().every((val, index) => val === question.answer.sort()[index]);
//                 break;
//             case 'match-the-following':
//                 isCorrect = question.answer.every((pair, index) => {
//                     return pair.left === question.left[index] && pair.right === currentAnswer[index];
//                 });
//                 break;
//             case 'reorder':
//                 isCorrect = currentAnswer.every((item, index) => item === question.answer[index]);
//                 break;
//             default:
//                 break;
//         }
//         return isCorrect;
//     }, [currentAnswer, currentQuestion]);
    
//     const handleSubmit = () => {
//         if (currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === '') return;
        
//         const isCorrect = checkAnswer();
        
//         setUserAnswers(prev => {
//             const otherAnswers = prev.filter(a => a.questionId !== currentQuestion.id);
//             return [...otherAnswers, {
//                 questionId: currentQuestion.id,
//                 answer: currentAnswer,
//                 isCorrect,
//                 status: 'answered'
//             }];
//         });
//         setIsSubmitted(true);
//     };

//     const handleNext = () => {
//         setIsSubmitted(false);
//         if (quizState === 'review-skipped') {
//             const newSkipped = skippedIndexes.slice(1);
//             setSkippedIndexes(newSkipped);
//             if (newSkipped.length > 0) {
//                 setCurrentQuestionIndex(newSkipped[0]);
//                 resetCurrentAnswer(questions[newSkipped[0]]);
//             } else {
//                 finishQuiz();
//             }
//         } else {
//              if (isLastQuestion) {
//                 if (skippedIndexes.length > 0) {
//                     setQuizState('review-skipped');
//                     setCurrentQuestionIndex(skippedIndexes[0]);
//                     resetCurrentAnswer(questions[skippedIndexes[0]]);
//                 } else {
//                     finishQuiz();
//                 }
//             } else {
//                 const nextIndex = currentQuestionIndex + 1;
//                 setCurrentQuestionIndex(nextIndex);
//                 resetCurrentAnswer(questions[nextIndex]);
//             }
//         }
//     };

//     const handleSkip = () => {
//         const questionId = currentQuestion.id;
//         if (!userAnswers.some(a => a.questionId === questionId)) {
//              setUserAnswers(prev => [...prev, {
//                 questionId: questionId,
//                 status: 'skipped'
//             }]);
//         }
        
//         if (quizState !== 'review-skipped' && !skippedIndexes.includes(currentQuestionIndex)) {
//             setSkippedIndexes(prev => [...prev, currentQuestionIndex]);
//         }

//         handleNext();
//     };

//     const finishQuiz = () => {
//         const answeredIds = userAnswers.map(a => a.questionId);
//         const unanswered = questions
//             .filter(q => !answeredIds.includes(q.id))
//             .map(q => ({ questionId: q.id, status: 'unanswered' }));
            
//         const finalAnswers = [...userAnswers, ...unanswered];
//         setUserAnswers(finalAnswers);

//         setQuizState('completed');
//         const score = finalAnswers.filter(a => a.isCorrect).length;
//         if (onComplete) {
//             onComplete({
//                 total_questions: questions.length,
//                 correct_answers: score
//             });
//         }
//     };

//     const handleRestart = () => {
//         if (onRestartQuiz) {
//             onRestartQuiz();
//         }
//         // Internal state reset
//         const preparedQuestions = quizData.map(q => {
//             if (q.type === 'match-the-following') {
//                 return { ...q, right: shuffleArray(q.right) };
//             }
//             if (q.type === 'reorder') {
//                 return { ...q, options: shuffleArray(q.options) };
//             }
//             return q;
//         });
//         setQuestions(preparedQuestions);
//         setCurrentQuestionIndex(0);
//         setUserAnswers([]);
//         setCurrentAnswer(null);
//         setIsSubmitted(false);
//         setSkippedIndexes([]);
//         setQuizState('in-progress');
//         resetCurrentAnswer(preparedQuestions[0]);
//     };

//     if (questions.length === 0) {
//         return <div className="d-flex justify-content-center align-items-center vh-100 bg-light"><p>Loading Quiz...</p></div>;
//     }
    
//     if (quizState === 'completed') {
//         return (
//             <div className="bg-light min-vh-100 py-4 px-2">
//                 <Results questions={questions} userAnswers={userAnswers} onRestart={handleRestart} />
//             </div>
//         );
//     }
    
//     const isAnswered = isSubmitted || userAnswers.some(a => a.questionId === currentQuestion.id && a.status === 'answered');
//     const correctness = isAnswered ? userAnswers.find(a => a.questionId === currentQuestion.id)?.isCorrect : null;
//     const showFinishButton = isAnswered && ((isLastQuestion && skippedIndexes.length === 0) || isLastSkippedQuestion);


//     return (
//         <div className="bg-light min-vh-100 d-flex align-items-center justify-content-center p-3 font-sans">
//             <div className="w-100 max-w-4xl bg-white rounded-2xl shadow-2xl p-4 md:p-8 transition-all duration-500">
//                 <div className="mb-6">
//                     <div className="flex justify-content-between align-items-center mb-2">
//                         <h1 className="text-2xl font-bold text-gray-700">Book Quiz</h1>
//                         <span className="text-sm font-semibold text-gray-500 bg-gray-200 px-3 py-1 rounded-full">
//                             {quizState === 'review-skipped' ? `Skipped ${skippedIndexes.indexOf(currentQuestionIndex) + 1} of ${skippedIndexes.length}` : `Question ${currentQuestionIndex + 1} of ${questions.length}`}
//                         </span>
//                     </div>
//                     <div className="w-full bg-gray-200 rounded-full h-2.5">
//                         <div className="bg-blue-600 h-2.5 rounded-full" style={{ width: `${((currentQuestionIndex + 1) / questions.length) * 100}%` }}></div>
//                     </div>
//                 </div>

//                 <div className="min-h-[300px] mb-6">
//                     {currentQuestion.type === 'single-choice' && <SingleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                     {currentQuestion.type === 'multiple-choice' && <MultipleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                     {currentQuestion.type === 'match-the-following' && <MatchTheFollowingQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                     {currentQuestion.type === 'reorder' && <ReorderQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                 </div>

//                 {isAnswered && (
//                      <div className={`text-center p-3 rounded-lg mb-4 text-lg font-semibold ${correctness ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
//                         {correctness ? 'Correct!' : 'Incorrect!'}
//                      </div>
//                 )}
                
//                 <div className="flex justify-content-between align-items-center">
//                     <div>
//                         {!isAnswered && (
//                             <button
//                                 onClick={handleSkip}
//                                 className="px-6 py-3 font-semibold text-gray-600 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors flex items-center"
//                             >
//                                 <SkipForward className="h-5 w-5 mr-2" />
//                                 Skip
//                             </button>
//                         )}
//                     </div>
//                     <div className="flex items-center space-x-4">
//                         {!showFinishButton && quizState !== 'review-skipped' && (
//                             <button
//                                 onClick={finishQuiz}
//                                 className="px-6 py-3 font-semibold text-red-600 bg-red-100 rounded-lg hover:bg-red-200 transition-colors"
//                             >
//                                 Submit Quiz
//                             </button>
//                         )}

//                         {isAnswered ? (
//                             showFinishButton ? (
//                                 <button
//                                     onClick={finishQuiz}
//                                     className="px-8 py-3 font-bold text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors shadow-lg"
//                                 >
//                                     Finish Quiz
//                                 </button>
//                             ) : (
//                                 <button
//                                     onClick={handleNext}
//                                     className="px-8 py-3 font-bold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors flex items-center shadow-lg"
//                                 >
//                                     Next Question <ArrowRight className="h-5 w-5 ml-2" />
//                                 </button>
//                             )
//                         ) : (
//                             <button
//                                 onClick={handleSubmit}
//                                 className="px-8 py-3 font-bold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed shadow-lg"
//                                 disabled={currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === ''}
//                             >
//                                 Submit
//                             </button>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }


// import React, { useState, useEffect, useCallback, useMemo } from 'react';
// import { Button, Form, Card, ProgressBar, Alert, Row, Col, Container, ButtonGroup, Badge, ListGroup } from 'react-bootstrap';
// import { Check, X, ChevronsUpDown, ArrowRight, SkipForward, RotateCcw, Filter, ArrowDown } from 'lucide-react';

// // --- HELPER FUNCTIONS & UTILS ---
// const shuffleArray = (array) => {
//     if (!Array.isArray(array)) return []; // Defensive check
//     return [...array].sort(() => Math.random() - 0.5);
// };

// // --- SUB-COMPONENTS (Styled with React Bootstrap) ---

// const SingleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => (
//     <div>
//         <p className="h5 fw-bold mb-4">{question}</p>
//         <Form><div className="d-grid gap-3">{(options || []).map((option, index) => (
//             // Form.Check renders a <label> which is clickable.
//             // The custom CSS will ensure the input is aligned correctly inside it.
//             <Form.Check key={index} type="radio" id={`sc-${index}`} name="single-choice" value={option}
//                 label={<span className="ms-2 fw-medium">{option}</span>}
//                 checked={userAnswer === option} onChange={(e) => onAnswer(e.target.value)} disabled={submitted}
//                 className={`p-3 border rounded-3 quiz-option ${userAnswer === option ? 'selected' : ''}`} />
//         ))}</div></Form>
//     </div>
// );

// const MultipleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => {
//     const currentAnswer = userAnswer || []; // Defensive check
//     const handleCheckboxChange = (option) => {
//         const newAnswer = currentAnswer.includes(option) ? currentAnswer.filter(item => item !== option) : [...currentAnswer, option];
//         onAnswer(newAnswer);
//     };
//     return (
//         <div>
//             <p className="h5 fw-bold mb-4">{question}</p>
//             <Form><div className="d-grid gap-3">{(options || []).map((option, index) => (
//                 <Form.Check key={index} type="checkbox" id={`mc-${index}`}
//                     label={<span className="ms-2 fw-medium">{option}</span>}
//                     checked={currentAnswer.includes(option)} onChange={() => handleCheckboxChange(option)} disabled={submitted}
//                     className={`p-3 border rounded-3 quiz-option ${currentAnswer.includes(option) ? 'selected' : ''}`} />
//             ))}</div></Form>
//         </div>
//     );
// };

// const MatchTheFollowingQuestion = ({ question, left, userAnswer, onAnswer, submitted }) => {
//     const handleDragStart = (e, index) => { if (submitted) return; e.dataTransfer.setData('draggedIndex', index); };
//     const handleDragOver = (e) => { if (submitted) return; e.preventDefault(); };
//     const handleDrop = (e, dropIndex) => {
//         if (submitted) return;
//         const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
//         const newRightItems = [...(userAnswer || [])];
//         const [draggedItem] = newRightItems.splice(draggedIndex, 1);
//         newRightItems.splice(dropIndex, 0, draggedItem);
//         onAnswer(newRightItems);
//     };
//     return (
//         <div>
//             <p className="h5 fw-bold mb-4">{question}</p>
//             <Row className="justify-content-center">
//                 <Col xs={5} className="d-grid gap-3">
//                     {(left || []).map((item, index) => <div key={index} className="p-3 bg-light border rounded-3 d-flex align-items-center justify-content-center text-center" style={{ minHeight: '60px' }}>{item}</div>)}
//                 </Col>
//                 <Col xs={5} className="d-grid gap-3">
//                     {(userAnswer || []).map((item, index) => <div key={index} draggable={!submitted} onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)}
//                         className={`p-3 bg-white border-2 border-dashed rounded-3 d-flex align-items-center justify-content-between text-center ${!submitted ? 'cursor-grab' : 'cursor-not-allowed bg-light'}`} style={{ minHeight: '60px' }}>
//                         <span>{item}</span>{!submitted && <ChevronsUpDown size={20} className="text-muted" />}</div>)}
//                 </Col>
//             </Row>
//         </div>
//     );
// };

// const ReorderQuestion = ({ question, userAnswer, onAnswer, submitted }) => {
//     const handleDragStart = (e, index) => { if (submitted) return; e.dataTransfer.setData('draggedIndex', index); };
//     const handleDragOver = (e) => { if (submitted) return; e.preventDefault(); };
//     const handleDrop = (e, dropIndex) => {
//         if (submitted) return;
//         const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
//         const newItems = [...(userAnswer || [])];
//         const [draggedItem] = newItems.splice(draggedIndex, 1);
//         newItems.splice(dropIndex, 0, draggedItem);
//         onAnswer(newItems);
//     };
//     return (
//         <div>
//             <p className="h5 fw-bold mb-4">{question}</p>
//             <div className="d-grid gap-3 mx-auto" style={{ maxWidth: '400px' }}>{(userAnswer || []).map((item, index) => <div key={index} draggable={!submitted} onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)}
//                 className={`p-3 bg-white border-2 border-dashed rounded-3 d-flex align-items-center justify-content-between ${!submitted ? 'cursor-grab' : 'cursor-not-allowed bg-light'}`}>
//                 <span>{index + 1}. {item}</span>{!submitted && <ChevronsUpDown size={20} className="text-muted" />}</div>)}
//             </div>
//         </div>
//     );
// };

// const Results = ({ questions, userAnswers, onRestart }) => {
//     const [filter, setFilter] = useState('all');
//     const score = useMemo(() => userAnswers.filter(ans => ans.isCorrect).length, [userAnswers]);

//     const filteredQuestions = useMemo(() => {
//         if (filter === 'all') return questions;
//         return questions.filter(q => {
//             const answer = userAnswers.find(a => a.questionId === q.id);
//             if (filter === 'correct') return answer?.isCorrect;
//             if (filter === 'incorrect') return answer && answer.status === 'answered' && !answer.isCorrect;
//             if (filter === 'unanswered') return !answer || answer.status !== 'answered';
//             return true;
//         });
//     }, [filter, questions, userAnswers]);

//     const ReorderVisualizer = ({ items, title, variant }) => (
//         <div>
//             <h6 className="fw-bold text-muted mb-2">{title}</h6>
//             <ListGroup variant="flush">{(items || []).map((item, index) => (
//                 <ListGroup.Item key={index} variant={variant} className="d-flex align-items-center">{index + 1}. <span className="ms-2">{item}</span></ListGroup.Item>
//             ))}</ListGroup>
//         </div>
//     );
    
//     const MatchVisualizer = ({ left, right, title, variant }) => (
//         <div>
//             <h6 className="fw-bold text-muted mb-2">{title}</h6>
//             {(left || []).map((leftItem, index) => (
//                 <Row key={index} className="g-2 mb-1 align-items-center">
//                     <Col xs={5} className="text-end text-muted">{leftItem}</Col>
//                     <Col xs={2} className="text-center"><ArrowRight size={16} className="text-muted" /></Col>
//                     <Col xs={5}><span className={`d-block p-1 rounded bg-${variant}-subtle`}>{(right || [])[index]}</span></Col>
//                 </Row>
//             ))}
//         </div>
//     );

//     return (
//         <Container style={{ maxWidth: '800px' }} className="py-4">
//             <h2 className="h2 fw-bold text-dark mb-4 text-center">Quiz Results</h2>
//             <Card className="p-4 shadow-lg mb-5 text-center">
//                 <Card.Body>
//                     <p className="fs-5 text-dark">Your Score:</p>
//                     <p className="display-4 fw-bold text-primary my-2">{score} / {questions.length}</p>
//                     <p className="fs-5 text-muted">{questions.length > 0 ? Math.round((score / questions.length) * 100) : 0}%</p>
//                     <Button variant="primary" onClick={onRestart} className="mt-4">
//                         <RotateCcw size={18} className="me-2" /> Retake Quiz
//                     </Button>
//                 </Card.Body>
//             </Card>
            
//             <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-4">
//                 <h3 className="h4 fw-bold text-dark mb-3 mb-sm-0">Review Answers</h3>
//                 <ButtonGroup size="sm">
//                     {['all', 'correct', 'incorrect', 'unanswered'].map(f => (
//                         <Button key={f} variant={filter === f ? 'primary' : 'outline-secondary'} onClick={() => setFilter(f)} className="text-capitalize">
//                             {f}
//                         </Button>
//                     ))}
//                 </ButtonGroup>
//             </div>

//             <div className="d-grid gap-3">
//                 {filteredQuestions.map((q, index) => {
//                     const answer = userAnswers.find(a => a.questionId === q.id);
//                     const isAnswered = answer?.status === 'answered';
//                     const isCorrect = answer?.isCorrect || false;
//                     let variant = !isAnswered ? 'secondary' : isCorrect ? 'success' : 'danger';
                    
//                     return (
//                         <Card key={q.id} className={`shadow-sm border-start border-5 border-${variant}`}>
//                             <Card.Header className="d-flex justify-content-between align-items-center bg-light bg-opacity-50">
//                                 <p className="fw-bold mb-0">{index + 1}. {q.question}</p>
//                                 <div>
//                                     {!isAnswered && <Badge bg="secondary">Unanswered</Badge>}
//                                     {isAnswered && isCorrect && <Badge bg="success">Correct</Badge>}
//                                     {isAnswered && !isCorrect && <Badge bg="danger">Incorrect</Badge>}
//                                 </div>
//                             </Card.Header>
//                             <Card.Body className="p-4">
//                                 {!isAnswered && <p className="text-muted fst-italic">You did not answer this question.</p>}
                                
//                                 {q.type === 'reorder' && isAnswered && (
//                                     <Row><Col md={6}><ReorderVisualizer items={answer.answer} title="Your Order" variant="primary" /></Col>
//                                     {!isCorrect && <Col md={6}><ReorderVisualizer items={q.answer} title="Correct Order" variant="success" /></Col>}</Row>
//                                 )}
                                
//                                 {q.type === 'match-the-following' && isAnswered && (
//                                     <Row><Col md={6}><MatchVisualizer left={q.left} right={answer.answer} title="Your Matches" variant="primary" /></Col>
//                                     {!isCorrect && <Col md={6}><MatchVisualizer left={q.answer.map(p=>p.left)} right={q.answer.map(p=>p.right)} title="Correct Matches" variant="success" /></Col>}</Row>
//                                 )}

//                                 {q.type !== 'reorder' && q.type !== 'match-the-following' && isAnswered && (
//                                     <div>
//                                         <p><strong className="text-muted">Your Answer:</strong> {Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer}</p>
//                                         {!isCorrect && <p className="mt-2"><strong className="text-muted">Correct Answer:</strong> {Array.isArray(q.answer) ? q.answer.join(', ') : q.answer}</p>}
//                                     </div>
//                                 )}
//                             </Card.Body>
//                         </Card>
//                     );
//                 })}
//             </div>
//         </Container>
//     );
// };


// // --- MAIN QUIZ COMPONENT ---
// export default function QuizPlayer({ quizData, onComplete, onRestartQuiz }) {
//     const [questions, setQuestions] = useState([]);
//     const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
//     const [userAnswers, setUserAnswers] = useState([]);
//     const [currentAnswer, setCurrentAnswer] = useState(null);
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [skippedIndexes, setSkippedIndexes] = useState([]);
//     const [quizState, setQuizState] = useState('in-progress');

//     const initializeQuiz = useCallback((data) => {
//         if (!data || !Array.isArray(data) || data.length === 0) return;
//         const preparedQuestions = data.map(q => {
//             if (q.type === 'match-the-following') return { ...q, right: shuffleArray(q.right) };
//             if (q.type === 'reorder') return { ...q, options: shuffleArray(q.options) };
//             return q;
//         });
//         setQuestions(preparedQuestions);
//         resetCurrentAnswer(preparedQuestions[0]);
//         setCurrentQuestionIndex(0);
//         setUserAnswers([]);
//         setIsSubmitted(false);
//         setSkippedIndexes([]);
//         setQuizState('in-progress');
//     }, []);
    
//     useEffect(() => {
//         initializeQuiz(quizData);
//     }, [quizData, initializeQuiz]);

//     const resetCurrentAnswer = (question) => {
//         if (!question) return;
//         switch (question.type) {
//             case 'single-choice': setCurrentAnswer(''); break;
//             case 'multiple-choice': setCurrentAnswer([]); break;
//             case 'match-the-following': setCurrentAnswer(question.right || []); break;
//             case 'reorder': setCurrentAnswer(question.options || []); break;
//             default: setCurrentAnswer(null);
//         }
//     };
    
//     const checkAnswer = useCallback(() => {
//         const question = questions[currentQuestionIndex];
//         if (!question || currentAnswer === null) return false;
//         let isCorrect = false;
//         switch (question.type) {
//             case 'single-choice': isCorrect = currentAnswer === question.answer; break;
//             case 'multiple-choice':
//                  isCorrect = Array.isArray(currentAnswer) && Array.isArray(question.answer) && currentAnswer.length === question.answer.length && currentAnswer.sort().every((v, i) => v === question.answer.sort()[i]);
//                 break;
//             case 'match-the-following':
//                 isCorrect = Array.isArray(question.answer) && question.answer.every((p, i) => p.left === question.left[i] && p.right === currentAnswer[i]);
//                 break;
//             case 'reorder':
//                 isCorrect = Array.isArray(question.answer) && currentAnswer.every((item, i) => item === question.answer[i]);
//                 break;
//             default: break;
//         }
//         return isCorrect;
//     }, [currentAnswer, questions, currentQuestionIndex]);
    
//     const handleSubmit = () => {
//         if (currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === '') return;
//         const isCorrect = checkAnswer();
//         setUserAnswers(prev => [...prev.filter(a => a.questionId !== currentQuestion.id), {
//             questionId: currentQuestion.id, answer: currentAnswer, isCorrect, status: 'answered'
//         }]);
//         setIsSubmitted(true);
//     };

//     const handleNext = () => {
//         setIsSubmitted(false);
//         let nextIndex;
//         if (quizState === 'review-skipped') {
//             const newSkipped = skippedIndexes.slice(1);
//             setSkippedIndexes(newSkipped);
//             if (newSkipped.length > 0) {
//                 nextIndex = newSkipped[0];
//             } else {
//                 finishQuiz(); return;
//             }
//         } else {
//             if (currentQuestionIndex === questions.length - 1) {
//                 if (skippedIndexes.length > 0) {
//                     setQuizState('review-skipped');
//                     nextIndex = skippedIndexes[0];
//                 } else {
//                     finishQuiz(); return;
//                 }
//             } else {
//                 nextIndex = currentQuestionIndex + 1;
//             }
//         }
//         setCurrentQuestionIndex(nextIndex);
//         resetCurrentAnswer(questions[nextIndex]);
//     };

//     const handleSkip = () => {
//         const questionId = currentQuestion.id;
//         if (!userAnswers.some(a => a.questionId === questionId)) {
//              setUserAnswers(prev => [...prev, { questionId, status: 'skipped' }]);
//         }
//         if (quizState !== 'review-skipped' && !skippedIndexes.includes(currentQuestionIndex)) {
//             setSkippedIndexes(prev => [...prev, currentQuestionIndex]);
//         }
//         handleNext();
//     };

//     const finishQuiz = () => {
//         const answeredIds = userAnswers.map(a => a.questionId);
//         const unanswered = questions.filter(q => !answeredIds.includes(q.id)).map(q => ({ questionId: q.id, status: 'unanswered' }));
//         const finalAnswers = [...userAnswers, ...unanswered];
//         setUserAnswers(finalAnswers);
//         setQuizState('completed');
//         const score = finalAnswers.filter(a => a.isCorrect).length;
//         if (onComplete) {
//             onComplete({ total_questions: questions.length, correct_answers: score });
//         }
//     };

//     const handleRestart = () => {
//         if (onRestartQuiz) onRestartQuiz();
//         initializeQuiz(quizData);
//     };

//     if (questions.length === 0) {
//         return <div className="d-flex justify-content-center align-items-center p-5"><p>Loading Quiz...</p></div>;
//     }
    
//     if (quizState === 'completed') {
//         return <Results questions={questions} userAnswers={userAnswers} onRestart={handleRestart} />;
//     }
    
//     const currentQuestion = questions[currentQuestionIndex];
//     if (!currentQuestion) {
//         return <div className="d-flex justify-content-center align-items-center p-5"><p>Loading Question...</p></div>;
//     }
//     const isAnswered = isSubmitted || userAnswers.some(a => a.questionId === currentQuestion.id && a.status === 'answered');
//     const correctness = isAnswered ? userAnswers.find(a => a.questionId === currentQuestion.id)?.isCorrect : null;
//     const isLastQuestion = currentQuestionIndex === questions.length - 1;
//     const showFinishButtonAfterAnswer = isAnswered && (isLastQuestion || (quizState === 'review-skipped' && skippedIndexes.length === 1));

//     return (
//         <>
//             {/* This style tag provides the CSS fixes for react-bootstrap's Form.Check */}
//             <style type="text/css">
//                 {`
//                     .quiz-option {
//                         display: flex !important;
//                         align-items: center;
//                         cursor: pointer;
//                     }
//                     .quiz-option .form-check-input {
//                         margin-top: 0 !important;
//                         float: none !important;
//                         margin-right: 0.75em !important;
//                         /* The input itself is a direct child now, so this works */
//                     }
//                     .quiz-option.selected {
//                         background-color: var(--bs-primary-bg-subtle);
//                         border-color: var(--bs-primary);
//                     }
//                 `}
//             </style>
//             <Card className="w-100 border-0">
//                 <Card.Body className="p-4 p-md-5">
//                     <div className="mb-4">
//                         <div className="d-flex justify-content-between align-items-center mb-2">
//                             <h1 className="h4 fw-bold text-dark">Book Quiz</h1>
//                             <Badge bg="secondary" pill>
//                                 {quizState === 'review-skipped' ? `Skipped ${skippedIndexes.indexOf(currentQuestionIndex) + 1}/${skippedIndexes.length}` : `Question ${currentQuestionIndex + 1}/${questions.length}`}
//                             </Badge>
//                         </div>
//                         <ProgressBar animated now={((userAnswers.filter(a => a.status === 'answered').length) / questions.length) * 100} />
//                     </div>
//                     <div style={{ minHeight: '300px' }} className="mb-4">
//                         {currentQuestion.type === 'single-choice' && <SingleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                         {currentQuestion.type === 'multiple-choice' && <MultipleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                         {currentQuestion.type === 'match-the-following' && <MatchTheFollowingQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                         {currentQuestion.type === 'reorder' && <ReorderQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
//                     </div>
//                     {isAnswered && <Alert variant={correctness ? 'success' : 'danger'} className="text-center fw-bold fs-5">{correctness ? 'Correct!' : 'Incorrect!'}</Alert>}
//                     <div className="d-flex justify-content-between align-items-center mt-4">
//                         <div>
//                             {!isAnswered && (
//                                 <Button variant="secondary" onClick={handleSkip} size="sm">
//                                     <SkipForward size={16} className="me-1" /> Skip
//                                 </Button>
//                             )}
//                         </div>
//                         <div className="d-flex align-items-center gap-2">
//                             {!isAnswered && (
//                                 <Button variant="danger" onClick={finishQuiz} size="sm">Submit Quiz</Button>
//                             )}
//                             {isAnswered ? (
//                                 showFinishButtonAfterAnswer ? (
//                                     <Button variant="success" onClick={finishQuiz}>Finish Quiz</Button>
//                                 ) : (
//                                     <Button variant="primary" onClick={handleNext}>Next Question <ArrowRight size={18} className="ms-2" /></Button>
//                                 )
//                             ) : (
//                                 <Button variant="primary" onClick={handleSubmit} disabled={currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === ''}>
//                                     Submit Answer
//                                 </Button>
//                             )}
//                         </div>
//                     </div>
//                 </Card.Body>
//             </Card>
//         </>
//     );
// }



import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Button, Form, Card, ProgressBar, Alert, Row, Col, Container, ButtonGroup, Badge, ListGroup } from 'react-bootstrap';
import { Check, X, ChevronsUpDown, ArrowRight, SkipForward, RotateCcw, Filter, ArrowDown } from 'lucide-react';

import axiosInstance from '../utils/axios';

// --- HELPER FUNCTIONS & UTILS ---
const shuffleArray = (array) => {
    if (!Array.isArray(array)) return []; // Defensive check
    return [...array].sort(() => Math.random() - 0.5);
};

// --- SUB-COMPONENTS (Styled with React Bootstrap) ---

const SingleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => (
    <div>
        <p className="h5 fw-bold mb-4">{question}</p>
        <Form>
            <div className="d-grid gap-3">
                {(options || []).map((option, index) => (
                    // <Form.Check key={index} type="radio" id={`sc-${index}`} name="single-choice" value={option}
                    //     label={<span className="ms-2 fw-medium">{option}</span>}
                    //     checked={userAnswer === option} onChange={(e) => onAnswer(e.target.value)} disabled={submitted}
                    //     className={`p-3 border rounded-3 quiz-option ${userAnswer === option ? 'selected' : ''}`} />
                    <Form.Check
                        key={index}
                        type="radio"
                        name="mcq"
                        id={`option-${index}`}
                        label={option}
                        value={option}
                        checked={userAnswer === option}
                        onChange={(e) => onAnswer(e.target.value)}
                        disabled={submitted}
                        className="option-card"
                        />
                ))}
            </div>
        </Form>
    </div>
);

const MultipleChoiceQuestion = ({ question, options, userAnswer, onAnswer, submitted }) => {
    const currentAnswer = userAnswer || []; // Defensive check
    const handleCheckboxChange = (option) => {
        const newAnswer = currentAnswer.includes(option) ? currentAnswer.filter(item => item !== option) : [...currentAnswer, option];
        onAnswer(newAnswer);
    };
    return (
        <div>
            <p className="h5 fw-bold mb-4">{question}</p>
            <Form><div className="d-grid gap-3">{(options || []).map((option, index) => (
                <Form.Check key={index} type="checkbox" id={`mc-${index}`}
                    label={<span className="ms-2 fw-medium">{option}</span>}
                    checked={currentAnswer.includes(option)} onChange={() => handleCheckboxChange(option)} disabled={submitted}
                    className={`p-3 border rounded-3 quiz-option ${currentAnswer.includes(option) ? 'selected' : ''}`} />
            ))}</div></Form>
        </div>
    );
};

const MatchTheFollowingQuestion = ({ question, left, userAnswer, onAnswer, submitted }) => {
    const handleDragStart = (e, index) => { if (submitted) return; e.dataTransfer.setData('draggedIndex', index); };
    const handleDragOver = (e) => { if (submitted) return; e.preventDefault(); };
    const handleDrop = (e, dropIndex) => {
        if (submitted) return;
        const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
        const newRightItems = [...(userAnswer || [])];
        const [draggedItem] = newRightItems.splice(draggedIndex, 1);
        newRightItems.splice(dropIndex, 0, draggedItem);
        onAnswer(newRightItems);
    };
    return (
        <div>
            <p className="h5 fw-bold mb-4">{question}</p>
            <Row className="justify-content-center">
                <Col xs={5} className="d-grid gap-3">
                    {(left || []).map((item, index) => <div key={index} className="p-3 bg-light border rounded-3 d-flex align-items-center justify-content-center text-center" style={{ minHeight: '60px' }}>{item}</div>)}
                </Col>
                <Col xs={5} className="d-grid gap-3">
                    {(userAnswer || []).map((item, index) => <div key={index} draggable={!submitted} onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)}
                        className={`p-3 bg-light border border-dashed rounded-3 d-flex align-items-center justify-content-between text-center ${!submitted ? 'cursor-grab' : 'cursor-not-allowed bg-light'}`} style={{ minHeight: '60px' }}>
                        <span>{item}</span>{!submitted && <ChevronsUpDown size={20} className="text-muted" />}</div>)}
                </Col>
            </Row>
        </div>
    );
};

const ReorderQuestion = ({ question, userAnswer, onAnswer, submitted }) => {
    const handleDragStart = (e, index) => { if (submitted) return; e.dataTransfer.setData('draggedIndex', index); };
    const handleDragOver = (e) => { if (submitted) return; e.preventDefault(); };
    const handleDrop = (e, dropIndex) => {
        if (submitted) return;
        const draggedIndex = parseInt(e.dataTransfer.getData('draggedIndex'));
        const newItems = [...(userAnswer || [])];
        const [draggedItem] = newItems.splice(draggedIndex, 1);
        newItems.splice(dropIndex, 0, draggedItem);
        onAnswer(newItems);
    };
    return (
        <div>
            <p className="h5 fw-bold mb-4">{question}</p>
            <div className="d-grid gap-3 mx-auto" style={{ maxWidth: '400px' }}>{(userAnswer || []).map((item, index) => <div key={index} draggable={!submitted} onDragStart={(e) => handleDragStart(e, index)} onDragOver={handleDragOver} onDrop={(e) => handleDrop(e, index)}
                className={`p-3 bg-light border-2 border-dashed rounded-3 d-flex align-items-center justify-content-between ${!submitted ? 'cursor-grab' : 'cursor-not-allowed bg-light'}`}>
                <span>{index + 1}. {item}</span>{!submitted && <ChevronsUpDown size={20} className="text-muted" />}</div>)}
            </div>
        </div>
    );
};

const Results = ({ questions, userAnswers, onRestart }) => {
    const [filter, setFilter] = useState('all');
    const score = useMemo(() => userAnswers.filter(ans => ans.isCorrect).length, [userAnswers]);

    const filteredQuestions = useMemo(() => {
        if (filter === 'all') return questions;
        return questions.filter(q => {
            const answer = userAnswers.find(a => a.questionId === q.id);
            if (filter === 'correct') return answer?.isCorrect;
            if (filter === 'incorrect') return answer && answer.status === 'answered' && !answer.isCorrect;
            if (filter === 'unanswered') return !answer || answer.status !== 'answered';
            return true;
        });
    }, [filter, questions, userAnswers]);

    const ReorderVisualizer = ({ items, title, variant }) => (
        <div>
            <h6 className="fw-bold text-muted mb-2">{title}</h6>
            <ListGroup variant="flush">{(items || []).map((item, index) => (
                <ListGroup.Item key={index} variant={variant} className="d-flex align-items-center">{index + 1}. <span className="ms-2">{item}</span></ListGroup.Item>
            ))}</ListGroup>
        </div>
    );
    
    const MatchVisualizer = ({ left, right, title, variant }) => (
        <div>
            <h6 className="fw-bold text-muted mb-2">{title}</h6>
            {(left || []).map((leftItem, index) => (
                <Row key={index} className="g-2 mb-1 align-items-center">
                    <Col xs={5} className="text-end text-muted">{leftItem}</Col>
                    <Col xs={2} className="text-center"><ArrowRight size={16} className="text-muted" /></Col>
                    <Col xs={5}><span className={`d-block p-1 rounded bg-${variant}-subtle`}>{(right || [])[index]}</span></Col>
                </Row>
            ))}
        </div>
    );

    return (
        <Container style={{ maxWidth: '800px' }} className="py-4">
            <h2 className="h2 fw-bold text-dark mb-4 text-center">Quiz Results</h2>
            <Card className="p-4 shadow-lg mb-5 text-center">
                <Card.Body>
                    <p className="fs-5 text-dark">Your Score:</p>
                    <p className="display-4 fw-bold text-primary my-2">{score} / {questions.length}</p>
                    <p className="fs-5 text-muted">{questions.length > 0 ? Math.round((score / questions.length) * 100) : 0}%</p>
                    <Button variant="primary" onClick={onRestart} className="mt-4">
                        <RotateCcw size={18} className="me-2" /> Retake Quiz
                    </Button>
                </Card.Body>
            </Card>
            
            <div className="d-flex flex-column flex-sm-row justify-content-between align-items-center mb-4">
                <h3 className="h4 fw-bold text-dark mb-3 mb-sm-0">Review Answers</h3>
                <ButtonGroup size="sm">
                    {['all', 'correct', 'incorrect', 'unanswered'].map(f => (
                        <Button key={f} variant={filter === f ? 'primary' : 'outline-secondary'} onClick={() => setFilter(f)} className="text-capitalize">
                            {f}
                        </Button>
                    ))}
                </ButtonGroup>
            </div>

            <div className="d-grid gap-3">
                {filteredQuestions.map((q, index) => {
                    const answer = userAnswers.find(a => a.questionId === q.id);
                    const isAnswered = answer?.status === 'answered';
                    const isCorrect = answer?.isCorrect || false;
                    let variant = !isAnswered ? 'secondary' : isCorrect ? 'success' : 'danger';
                    
                    return (
                        <Card key={q.id} className={`shadow-sm border-start border-5 border-${variant}`}>
                            <Card.Header className="d-flex justify-content-between align-items-center bg-light bg-opacity-50">
                                <p className="fw-bold mb-0">{index + 1}. {q.question}</p>
                                <div>
                                    {!isAnswered && <Badge bg="secondary">Unanswered</Badge>}
                                    {isAnswered && isCorrect && <Badge bg="success">Correct</Badge>}
                                    {isAnswered && !isCorrect && <Badge bg="danger">Incorrect</Badge>}
                                </div>
                            </Card.Header>
                            <Card.Body className="p-4">
                                {!isAnswered && <p className="text-muted fst-italic">You did not answer this question.</p>}
                                
                                {q.type === 'reorder' && isAnswered && (
                                    <Row><Col md={6}><ReorderVisualizer items={answer.answer} title="Your Order" variant="primary" /></Col>
                                    {!isCorrect && <Col md={6}><ReorderVisualizer items={q.answer} title="Correct Order" variant="success" /></Col>}</Row>
                                )}
                                
                                {q.type === 'match-the-following' && isAnswered && (
                                    <Row><Col md={6}><MatchVisualizer left={q.left} right={answer.answer} title="Your Matches" variant="primary" /></Col>
                                    {!isCorrect && <Col md={6}><MatchVisualizer left={q.answer.map(p=>p.left)} right={q.answer.map(p=>p.right)} title="Correct Matches" variant="success" /></Col>}</Row>
                                )}

                                {q.type !== 'reorder' && q.type !== 'match-the-following' && isAnswered && (
                                    <div>
                                        <p><strong className="text-muted">Your Answer:</strong> {Array.isArray(answer.answer) ? answer.answer.join(', ') : answer.answer}</p>
                                        {!isCorrect && <p className="mt-2"><strong className="text-muted">Correct Answer:</strong> {Array.isArray(q.answer) ? q.answer.join(', ') : q.answer}</p>}
                                    </div>
                                )}
                            </Card.Body>
                        </Card>
                    );
                })}
            </div>
        </Container>
    );
};


// --- MAIN QUIZ COMPONENT ---
export default function QuizPlayer({ quizData, quizId, onRestartQuiz }) {
    const [questions, setQuestions] = useState([]);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [userAnswers, setUserAnswers] = useState([]);
    const [currentAnswer, setCurrentAnswer] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [skippedIndexes, setSkippedIndexes] = useState([]);
    const [quizState, setQuizState] = useState('in-progress');

    const initializeQuiz = useCallback((data) => {
        if (!data || !Array.isArray(data) || data.length === 0) return;
        const preparedQuestions = data.map(q => {
            if (q.type === 'match-the-following') return { ...q, right: shuffleArray(q.right) };
            if (q.type === 'reorder') return { ...q, options: shuffleArray(q.options) };
            return q;
        });
        setQuestions(preparedQuestions);
        resetCurrentAnswer(preparedQuestions[0]);
        setCurrentQuestionIndex(0);
        setUserAnswers([]);
        setIsSubmitted(false);
        setSkippedIndexes([]);
        setQuizState('in-progress');
    }, []);
    
    useEffect(() => {
        initializeQuiz(quizData);
    }, [quizData, initializeQuiz]);

    const resetCurrentAnswer = (question) => {
        if (!question) return;
        switch (question.type) {
            case 'single-choice': setCurrentAnswer(''); break;
            case 'multiple-choice': setCurrentAnswer([]); break;
            case 'match-the-following': setCurrentAnswer(question.right || []); break;
            case 'reorder': setCurrentAnswer(question.options || []); break;
            default: setCurrentAnswer(null);
        }
    };
    
    const checkAnswer = useCallback(() => {
        const question = questions[currentQuestionIndex];
        if (!question || currentAnswer === null) return false;
        let isCorrect = false;
        switch (question.type) {
            case 'single-choice': isCorrect = currentAnswer === question.answer; break;
            case 'multiple-choice':
                 isCorrect = Array.isArray(currentAnswer) && Array.isArray(question.answer) && currentAnswer.length === question.answer.length && currentAnswer.sort().every((v, i) => v === question.answer.sort()[i]);
                break;
            case 'match-the-following':
                isCorrect = Array.isArray(question.answer) && question.answer.every((p, i) => p.left === question.left[i] && p.right === currentAnswer[i]);
                break;
            case 'reorder':
                isCorrect = Array.isArray(question.answer) && currentAnswer.every((item, i) => item === question.answer[i]);
                break;
            default: break;
        }
        return isCorrect;
    }, [currentAnswer, questions, currentQuestionIndex]);
    
    const handleSubmit = () => {
        if (currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === '') return;
        const isCorrect = checkAnswer();
        setUserAnswers(prev => [...prev.filter(a => a.questionId !== currentQuestion.id), {
            questionId: currentQuestion.id, answer: currentAnswer, isCorrect, status: 'answered'
        }]);
        setIsSubmitted(true);
    };

    const handleNext = () => {
        setIsSubmitted(false);
        let nextIndex;
        if (quizState === 'review-skipped') {
            const newSkipped = skippedIndexes.slice(1);
            setSkippedIndexes(newSkipped);
            if (newSkipped.length > 0) {
                nextIndex = newSkipped[0];
            } else {
                finishQuiz(); return;
            }
        } else {
            if (currentQuestionIndex === questions.length - 1) {
                if (skippedIndexes.length > 0) {
                    setQuizState('review-skipped');
                    nextIndex = skippedIndexes[0];
                } else {
                    finishQuiz(); return;
                }
            } else {
                nextIndex = currentQuestionIndex + 1;
            }
        }
        setCurrentQuestionIndex(nextIndex);
        resetCurrentAnswer(questions[nextIndex]);
    };

    const handleSkip = () => {
        const questionId = currentQuestion.id;
        if (!userAnswers.some(a => a.questionId === questionId)) {
             setUserAnswers(prev => [...prev, { questionId, status: 'skipped' }]);
        }
        if (quizState !== 'review-skipped' && !skippedIndexes.includes(currentQuestionIndex)) {
            setSkippedIndexes(prev => [...prev, currentQuestionIndex]);
        }
        handleNext();
    };

    const submitQuizScore = (scoreData) => {
        console.log(scoreData)
        // scoreData should be an object like { total_questions: 10, correct_answers: 8 }
        return axiosInstance.post(`/books/quizzes/${quizId}/scores/`, scoreData);
    };

    const finishQuiz = async () => {
        const answeredIds = userAnswers.map(a => a.questionId);
        const unanswered = questions.filter(q => !answeredIds.includes(q.id)).map(q => ({ questionId: q.id, status: 'unanswered' }));
        const finalAnswers = [...userAnswers, ...unanswered];
        setUserAnswers(finalAnswers);
        setQuizState('completed');
        const score = finalAnswers.filter(a => a.isCorrect).length;
        // if (onComplete) {
        //     onComplete({ total_questions: questions.length, correct_answers: score });
        // }

        try{
            await submitQuizScore({ total_questions: questions.length, correct_answers: score })
            console.log('Quiz score submitted successfully');
        } catch (err) {
            console.error(err);
        }
    };

    const handleRestart = () => {
        if (onRestartQuiz) onRestartQuiz();
        initializeQuiz(quizData);
    };

    if (questions.length === 0) {
        return <div className="d-flex justify-content-center align-items-center p-5"><p>Loading Quiz...</p></div>;
    }
    
    if (quizState === 'completed') {
        return <Results questions={questions} userAnswers={userAnswers} onRestart={handleRestart} />;
    }
    
    const currentQuestion = questions[currentQuestionIndex];
    if (!currentQuestion) {
        return <div className="d-flex justify-content-center align-items-center p-5"><p>Loading Question...</p></div>;
    }
    const isAnswered = isSubmitted || userAnswers.some(a => a.questionId === currentQuestion.id && a.status === 'answered');
    const correctness = isAnswered ? userAnswers.find(a => a.questionId === currentQuestion.id)?.isCorrect : null;
    const isLastQuestion = currentQuestionIndex === questions.length - 1;
    const showFinishButtonAfterAnswer = isAnswered && (isLastQuestion || (quizState === 'review-skipped' && skippedIndexes.length === 1));

    return (
        <>
            {/* This style tag provides the CSS fixes for react-bootstrap's Form.Check */}
            <style type="text/css">
                {`
                    .quiz-option {
                        display: flex !important;
                        align-items-center;
                        cursor: pointer;
                    }
                    .quiz-option .form-check-input {
                        margin-top: 0 !important;
                        float: none !important;
                        margin-right: 0.75em !important;
                    }
                    .quiz-option.selected {
                        background-color: var(--bs-primary-bg-subtle);
                        border-color: var(--bs-primary);
                    }

                    .option-card {
                    border: 1px solid #ddd;
                    border-radius: 8px;
                    padding: 10px 15px;
                    margin: 8px 0;
                    background: #fff;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    width: 100%;
                    }

                    .option-card input[type="radio"] {
                    margin-left: 10px;
                    margin-right: 10px;
                    transform: scale(1.2); /* optional: bigger radio */
                    }

                    .option-card label {
                    width: 100%;
                    cursor: pointer;
                    }
                `}
            </style>
            <Card className="w-100 border-0">
                <Card.Body className="p-4 p-md-5">
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h1 className="h4 fw-bold text-dark">Book Quiz</h1>
                            <Badge bg="secondary" pill>
                                {quizState === 'review-skipped' ? `Skipped ${skippedIndexes.indexOf(currentQuestionIndex) + 1}/${skippedIndexes.length}` : `Question ${currentQuestionIndex + 1}/${questions.length}`}
                            </Badge>
                        </div>
                        <ProgressBar animated now={((userAnswers.filter(a => a.status === 'answered').length) / questions.length) * 100} />
                    </div>
                    <div style={{ minHeight: '300px' }} className="mb-4">
                        {currentQuestion.type === 'single-choice' && <SingleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
                        {currentQuestion.type === 'multiple-choice' && <MultipleChoiceQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
                        {currentQuestion.type === 'match-the-following' && <MatchTheFollowingQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
                        {currentQuestion.type === 'reorder' && <ReorderQuestion {...currentQuestion} userAnswer={currentAnswer} onAnswer={setCurrentAnswer} submitted={isAnswered} />}
                    </div>
                    {isAnswered && <Alert variant={correctness ? 'success' : 'danger'} className="text-center fw-bold fs-5">{correctness ? 'Correct!' : 'Incorrect!'}</Alert>}
                    <div className="d-flex justify-content-between align-items-center mt-4">
                        <div>
                            {!isAnswered && (
                                <Button variant="secondary" onClick={handleSkip}>
                                    <SkipForward size={16} className="me-1" /> Skip
                                </Button>
                            )}
                        </div>
                        <div className="d-flex align-items-center gap-3">
                            {!isAnswered && (
                                <Button variant="danger" onClick={finishQuiz} size="sm">Submit Quiz</Button>
                            )}
                            {isAnswered ? (
                                showFinishButtonAfterAnswer ? (
                                    <Button variant="success" onClick={finishQuiz} size="lg">Finish Quiz</Button>
                                ) : (
                                    <Button variant="primary" onClick={handleNext} size="lg">Next Question <ArrowRight size={18} className="ms-2" /></Button>
                                )
                            ) : (
                                <Button variant="primary" onClick={handleSubmit} disabled={currentAnswer === null || (Array.isArray(currentAnswer) && currentAnswer.length === 0) || currentAnswer === ''}>
                                    Submit Answer
                                </Button>
                            )}
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    );
}

